import request from '@/router/axios'

export function fetchList(query) {
  return request({
    url: '/post/admin/searchkeyword/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/post/admin/searchkeyword',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/post/admin/searchkeyword/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/post/admin/searchkeyword/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/post/admin/searchkeyword',
    method: 'put',
    data: obj
  })
}
